import { render, staticRenderFns } from "./EditorTipTap.vue?vue&type=template&id=3f0043ad&scoped=true&"
import script from "./EditorTipTap.vue?vue&type=script&lang=js&"
export * from "./EditorTipTap.vue?vue&type=script&lang=js&"
import style0 from "./EditorTipTap.vue?vue&type=style&index=0&id=3f0043ad&lang=scss&scoped=true&"
import style1 from "./EditorTipTap.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0043ad",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
